module.exports = __webpack_public_path__ + "static/sc_13-4eff331b5a453eeed386670d4c781e92.jpg";